import React, { useState, Fragment } from 'react';
import styled from "styled-components"
import { Row, Col, Container } from "react-bootstrap";
import { Button, Form, Input, Select, message } from 'antd';

import { BPSPrimaryBtn } from "../styled/Buttons";
import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';

const constants = {
    specialCharacterCheckPatternWithSpace: /^[a-z0-9\s_.-]+$/i,
    specialCharacterCheckPattern: /^[a-z0-9_.-]+$/i,
    phoneNumberCheckPattern: /^(?:\d*)$/,
    checkPasswordPattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,32}$/
}

const ScheduleDemo = styled.div`

.ant-input:focus, .ant-input:focus-within, {
    border-color: #1c304c;
    box-shadow: none;
}

.ant-input:hover, .ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {
    border-color: #8DAED7;
}
`
const PROGRAMS = ['Channel Sales', 'Sales Contests', 'Rebates', 'Referrals', 'Employee Rewards', 'Payments', 'Custom Incentives'];


const PRODUCTS = ['Visa Prepaid Reward Cards', 'eGift Cards', 'Card Ordering'];
const { Option } = Select;
const sendContactInfo = gql`mutation ContactUsPublic($input: contactUsPublicInput) {
    contactUsPublic(input: $input) {
      message
    }
  }
`;

const ContactForm = () => {

    const [selectedItems, setSelectedItems] = useState<string[]>([]);

    const filteredPrograms = PROGRAMS.filter((o) => !selectedItems.includes(o));

    const filteredProducts = PRODUCTS.filter((o) => !selectedItems.includes(o));

    const [messageApi, contextHolder] = message.useMessage();
    const successMessage = <>
        <h4>Thank you for taking the frist step in exploring what Best Payment Solutions can do for your business.</h4>
        <div>
            Your message has been received and a representative from our team will reach out to you shortly.
        </div>
        <div>
            We look forward to working together!
        </div>
    </>

    const [form] = Form.useForm();
    const [sendContactInfoRequest] = useMutation(sendContactInfo, {
        onCompleted(data) {
            form.resetFields();
            messageApi.open({
                type: 'success',
                content: successMessage,
                duration: 30,
                style: {
                    width: "30vw",
                    margin: "auto auto",
                    marginTop: "10vh",
                }
            });
        },
        onError(error) {
            messageApi.open({
                type: 'error',
                content: "Something went wrong.Please try again",
                duration: 10,
                style: {
                    marginTop: "10vh"
                }
            });
        }
    });
    const onFinish = (values: any) => {
        console.log(values);
        sendContactInfoRequest({
            variables: {
                input: {
                    ...values
                }
            }
        })
        console.log('Success:', values);
    };
    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    return (

        <>
            <Container fluid>
                <ScheduleDemo>
                    <Form
                        name="contact"
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        layout='vertical'
                        form={form}
                        requiredMark={false}
                    >

                        <Row className="justify-content-center">
                            <Col>
                                <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Enter your name' }]}>
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Item name="email" label="Email" rules={[{ required: true, message: 'Enter a valid email address' }]}>
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item
                                    name="phone"
                                    label="Phone"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Enter your phone number',
                                            // pattern: /^[1-9][0-9]{9}$/,
                                        }
                                    ]}>
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Item name="companyName" label="Company Name" rules={[{ required: true, message: "Enter your company's name" }]}>
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item name="companyUrl" label="Company URL" rules={[{ required: true, message: "Enter the URL of your company's website" }]}>
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Item name="services" label="Programs I'm interested in">
                                    <Select
                                        mode="multiple"
                                        value={selectedItems}
                                        onChange={setSelectedItems}
                                        options={filteredPrograms.map((item) => ({
                                            value: item,
                                            label: item,
                                        }))}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Item name="products" label="Products I'm interested in">
                                    <Select
                                        mode="multiple"
                                        value={selectedItems}
                                        onChange={setSelectedItems}
                                        options={filteredProducts.map((item) => ({
                                            value: item,
                                            label: item,
                                        }))}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-center'>
                                <Form.Item>
                                    <BPSPrimaryBtn type='submit'>Submit</BPSPrimaryBtn>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </ScheduleDemo>
            </Container >
        </>
    );
}


export { ContactForm }
